import { FaChevronLeft } from "react-icons/fa";
import styles from "../../lib/Common/commonStyles";
import { saveOnDB } from "../../lib/Common/definedFunctions";
import { useTranslation } from "react-i18next";

const BackNextButtons = ({
  currentStep,
  setCurrentStep,
  onClick,
  title,
  setStep,
  showSave,
  backStep,
  values = {},
}) => {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-md-6 mb-3 mb-md-5  ">
        <div className="d-flex justify-content-start gap-2 gap-md-4 ">
          <button
            // modifying as back button only navigates to previous screen not to to save the data
            onClick={() => {
              if (showSave && backStep - 1 == currentStep) {
                setCurrentStep(4);
              } else {
                if (currentStep > 0) setCurrentStep(currentStep - 1);
                else setStep(1);
              }
            }}
            className="back-button "
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#B24BF3")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#B3A9BE")
            }
          >
            <FaChevronLeft color="421F66" className="" />
          </button>
          {showSave && (
            <button
              className="text-blue fontSize16Medium backgroundColorGreen next-button-responsive custom-pink-button "
              type="submit"
              onClick={() => {
                saveOnDB(values, false);
                if (currentStep < 4) onClick(4);
                else onClick();
              }}
            >
              {t("Save")}
            </button>
          )}
          <button
            type="submit"
            className="text-blue fontSize16Medium backgroundColorPink next-button-responsive custom-pink-button"
            onClick={() => {
              saveOnDB(values, false);
              if (currentStep < 3) onClick(currentStep + 1);
              else onClick();
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#B24BF3")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#FF53FF")}
          >
            {title ? <>{t(`${title}`)}</> : <>{t("Next")}</>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackNextButtons;
